class MCartDrawer extends HTMLElement {
  constructor() {
    super(),
      (this.cartDrawerInner = this.querySelector(".m-cart-drawer__inner")),
      (this.cartDrawerCloseIcon = this.querySelector(".m-cart-drawer__close")),
      (this.cartOverlay = this.querySelector(".m-cart__overlay")),
      (this.shippingToggle = this.querySelector("[shipping-text-toggle]")),
      this.shippingToggle.addEventListener("click", this.togglOpen.bind(this)),
      (this.shippingToggleContent = this.querySelector(
        "[shipping-text-toggle-content]"
      )),
      (this.rootUrl = window.Shopify.routes.root),
      this.setHeaderCartIconAccessibility(),
      this.cartDrawerCloseIcon.addEventListener("click", this.close.bind(this)),
      this.addEventListener("click", (t) => {
        t.target.closest(".m-cart-drawer__inner") !== this.cartDrawerInner &&
          this.close();
      });
  }
  togglOpen() {
    this.shippingToggle.classList.toggle("open"),
      this.shippingToggleContent.classList.toggle("m:hidden");
  }
  setHeaderCartIconAccessibility() {
    document.querySelectorAll(".m-cart-icon-bubble").forEach((t) => {
      t.setAttribute("role", "button"),
        t.setAttribute("aria-haspopup", "dialog"),
        t.addEventListener("click", (e) => {
          MinimogSettings.enable_cart_drawer &&
            (e.preventDefault(), this.open(t));
        });
    });
  }
  open(t) {
    console.log(t);
    t && this.setActiveElement(t),
      this.classList.add("m-cart-drawer--active"),
      requestAnimationFrame(() => {
        this.style.setProperty("--m-bg-opacity", "0.5"),
          this.cartDrawerInner.style.setProperty("--translate-x", "0");
      }),
      window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer),
      document.documentElement.classList.add("prevent-scroll");
  }
  close() {
    this.style.setProperty("--m-bg-opacity", "0"),
      this.cartDrawerInner.style.setProperty("--translate-x", "100%"),
      setTimeout(() => {
        this.classList.remove("m-cart-drawer--active"),
          document.documentElement.classList.remove("prevent-scroll");
      }, 300);
  }
  renderContents(t) {
    console.log("cart-drawer"),
      this.classList.contains("m-cart--empty") &&
        this.classList.remove("m-cart--empty"),
      (this.productId = t.id),
      (this.querySelector(
        "slide-popup .content-box .offers-coupon-list"
      ).innerHTML = this.getSectionInnerHTML(
        t.sections["cart-drawer"],
        "slide-popup .content-box .offers-coupon-list"
      )),
      (this.querySelector("[shipping-text-toggle-content]").innerHTML =
        this.getSectionInnerHTML(
          t.sections["cart-drawer"],
          "[shipping-text-toggle-content]"
        )),
      this.getSectionsToRender().forEach((e) => {
        (e.selector
          ? document.querySelector(e.selector)
          : document.getElementById(e.id)
        ).innerHTML = this.getSectionInnerHTML(t.sections[e.id], e.selector);
      }),
      setTimeout(() => {
        this.open();
      });
  }
  updateCartCount(t) {
    document
      .querySelectorAll("[m-cart-count-not-hidden]")
      .forEach((e) => (e.textContent = t)),
      document.querySelectorAll(".m-cart-count-bubble").forEach((e) => {
        t > 0
          ? ((e.textContent = t), e.classList.remove("m:hidden"))
          : e.classList.add("m:hidden");
      });
  }
  getCart() {
    return fetchJSON(this.rootUrl + "cart.json");
  }
  onCartDrawerUpdate(t = !0) {
    fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`)
      .then((t) => t.text())
      .then((e) => {
        this.getSectionsToRender().forEach((r) => {
          ("cart-items" === r.block || t) &&
            ((r.selector
              ? document.querySelector(r.selector)
              : document.getElementById(r.id)
            ).innerHTML = this.getSectionInnerHTML(e, r.selector));
        }),
          (this.querySelector(
            "slide-popup .content-box .offers-coupon-list"
          ).innerHTML = this.getSectionInnerHTML(
            e,
            "slide-popup .content-box .offers-coupon-list"
          )),
          (this.querySelector("[shipping-text-toggle-content]").innerHTML =
            this.getSectionInnerHTML(e, "[shipping-text-toggle-content]")),
          (this.querySelector("[cart-offer-popup]").innerHTML =
            this.getSectionInnerHTML(e, "[cart-offer-popup]"));
      })
      .catch((t) => {}),
      this.getCart().then((t) => {
        this.classList.toggle("m-cart--empty", 0 === t.item_count),
          this.updateCartCount(t.item_count);
      });
  }
  getSectionInnerHTML(t, e = ".shopify-section") {
    return new DOMParser().parseFromString(t, "text/html").querySelector(e)
      .innerHTML;
  }
  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "[data-minimog-cart-items]",
        block: "cart-items",
      },
      {
        id: "cart-drawer",
        selector: "[data-minimog-cart-discounts]",
        block: "cart-footer",
      },
      {
        id: "cart-drawer",
        selector: "[data-cart-subtotal]",
        block: "cart-footer",
      },
      {
        id: "cart-drawer",
        selector: "[data-minimog-gift-wrapping]",
        block: "cart-footer",
      },
      {
        id: "cart-drawer",
        selector: "[checkout-data-cart-subtotal]",
        block: "cart-footer",
      },
    ];
  }
  getSectionDOM(t, e = ".shopify-section") {
    return new DOMParser().parseFromString(t, "text/html").querySelector(e);
  }
  setActiveElement(t) {
    this.activeElement = t;
  }
}
customElements.define("m-cart-drawer", MCartDrawer);
class MCartDrawerItems extends MCartTemplate {
  getSectionsToRender() {
    return [
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-cart-items]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[cart-offer-popup]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-cart-discounts]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-cart-subtotal]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-gift-wrapping]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[checkout-data-cart-subtotal]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "slide-popup .content-box .offers-coupon-list",
      },
    ];
  }
}
customElements.define("m-cart-drawer-items", MCartDrawerItems);
